import React, { useState, useEffect } from 'react';
import Main_Spring from '../component/Spring/Main_Spring';
import Info_Spring from '../component/Spring/Info_Spring';
import Letter from '../component/Spring/Letter';
import Dday_Spring from '../component/Spring/Dday_Spring';
import Message_Spring from '../component/Spring/Message_Spring';
import Location_Spring from '../component/Spring/Location_Spring';
import Footer from '../component/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../component/MotionWrapper';
import axios from 'axios';
import Save_Date from '../component/Save_Date';
import Loading from '../component/Loading';
import Location_Desc from '../component/Location/Location_Desc';
import Music from '../component/Music';
import AccountList from '../component/Account/AccountList';
import Sharing from '../component/Sharing';
import GalleryList from '../component/Gallery/GalleryList';
import Information from '../component/Information';
import CallInfo from '../component/CallInfo';
import Interview_Spring from '../component/Spring/Interview_Spring';
import Video from '../component/Video';

const KimSeoA = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "장재은 ♥ 김서아 결혼합니다.";
    const openDesc = "3월 2일 오후 3시30분";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/76/thumb.jpg";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen:''
    });
    
    const conceptStyle = {
        concept: "SPRING",
        // 블루 
        titleColor: "#1F5093",
        pointColor: "#1F5093",
        btnBgColor: "#1F5093",
        fontColor: "#313131",
        btnFontColor: "#ffffff",
        chatBgColor: "#fefaf9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const groomAccountList = [
        {
            role: "신랑",
            name: "장재은",
            bank: "우리은행",
            accountNumber : "1002-1332-55677",
            isKakao : false
        },
        {
            role: "신랑 부",
            name: "장성의",
            bank: "우리은행",
            accountNumber : "1005-404-554462",
            isKakao : false
        }
    ]


    const brideAccountList = [
        {
            role: "신부",
            name: "김서아",
            bank: "카카오뱅크",
            accountNumber : "3333-13-8086194",
            isKakao : false
        },
        {
            role: "신부 모",
            name: "이정화",
            bank: "농협은행",
            accountNumber : "3022317695611",
            isKakao : false
        }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "장재은",
            call: "010-4254-1026"
        },
        {
            role: "신랑 부",
            name: "장성의",
            call: "010-4520-4368"
        },
        {
            role: "신랑 모",
            name: "최영희(민경)",
            call: "010-9503-8776"
        }
    ]
    const brideCallInfoList = [
        {
            role: "신부",
            name: "김서아",
            call: "010-6248-6956"
        },
        {
            role: "신부 부",
            name: "김승배",
            call: "010-2300-3450"
        },
        {
            role: "신부 모",
            name: "이정화",
            call: "010-2317-6956"
        }
    ]


    const msg1 = "가을에 만나 \n사계절을 보내고 \n따뜻한 봄이 시작되는 3월,\n빛나는 그 날에 \n저희 두 사람 결혼합니다.";
    const msg2 = "소중한 걸음으로 함께 축복해 주세요";


    const lng = 127.111455922512;
    const lat = 37.4005276924905;
    
    const placeTelNum = "031 703 0116";

    const forCar = "경부고속도로 판교IC(톨게이트) 차출 후 좌회전, \n약 700m 직진하여 사거리에서 우회전 (SK 주유소 뒤)";
    const forBus = "390번 : 동안교 하차\n4000번 : 테크노육교 하차\n101, 330, 350, 390, 4000번 : 차그룹컨소시엄 하차"
    const forSubway = "신분당선 판교역 1번 출구 직도보 6분 소요\n셔틀버스 10분 간격 운행 (판교역 1번출구 베스킨라빈스 \n앞 승차)";

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다.";


    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "어떻게잊어",
            brideAnswer: "절대못잊어"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "걱정설렘반",
            brideAnswer: "신나는기분"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "선을지키자",
            brideAnswer: "나만믿어봐"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "1+1이야",
            brideAnswer: "살찔각오해"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "평생함께해",
            brideAnswer: "잘해봅시다"
        }
    ]

    // const informationList =[
    //     {
    //         title : "화환 안내",
    //         content : "화환은 정중히 사양합니다. \n축하해주시는 따듯한 마음만 \n감사히 받겠습니다. "
    //     }
    // ]

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();
    }, []);

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);


    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    if (!weddingData || !conceptStyle) return <Loading color={weddingData.pointColor}/>;
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#FF8A83"} loading={loading} />
            ) : (
            <>
            <Music concept={conceptStyle.concept}/>
            <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
            <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
            <Info_Spring weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
            <Letter title={"우리 결혼 합니다"} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle}/>
            <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
            <Dday_Spring isAttendFromClose={true} groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                <Video width={"90%"} height={"622px"} url={"https://moodsean.s3.ap-northeast-2.amazonaws.com/76/video.mp4"} conceptStyle={conceptStyle}/>
                <MotionWrapper initialY={50}>
                <GalleryList color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    <MotionWrapper initialY={70}>
                    <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                        <MotionWrapper initialY={70}>
                            <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} conceptStyle={conceptStyle} btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.pointColor}/>
                            <MotionWrapper initialY={50}>
                                {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                                <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                                <Location_Desc forSubway={forSubway} forBus={forBus} forCar={forCar} conceptStyle={conceptStyle}/>
                                <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                                <Footer />
                            </MotionWrapper>
                        </MotionWrapper>
                    </MotionWrapper>
                </MotionWrapper>
            </>
            )}
        </div>
    );
};

export default KimSeoA;
